<template>
  <div class="file-preview-container">
    <!-- doc、docx、xls、xlsx -->
    <iframe class="iframe" ref="iframe_pdf" :src="src" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: 'file-preview',
  data () {
    return {
      src: 'https://view.officeapps.live.com/op/view.aspx?src=',
      type: ''
    }
  },
  methods: {
    getDownLoadUrl (path) {
      return path.includes('USER') ? sessionStorage.getItem('ossDownloadUrl') : sessionStorage.getItem('ossDownloadUrl')
    }
  },
  async created () {
    if (!sessionStorage.getItem('ossDownloadUrl')) {
      await this.$axios.get('/shared-api/files/oss').then(res => {
        sessionStorage.setItem('ossDownloadUrl', res.data.host)
      })
    }
    if (this.$route.query.name) {
      document.title = this.$route.query.name
    }
    this.src = this.$route.query.src.includes('http') ? this.$route.query.src : `${this.src}${this.getDownLoadUrl(this.$route.query.src)}${this.$route.query.src}`
  }
}
</script>

<style lang="scss">
  .file-preview-container {
    height: 100%;
    width: 100%;

    .iframe {
      height: 100%;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/file-preview.vue